/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";

/** Common Components */
import FormCreator from "../../../../../../../components/finalForms/FormCreator";
import MolGrid, { Column } from "@moltech/molui/molgrid";
import Buttons from "../../../../../../../components/ui/button/Buttons";

/** Configuration files */
import { addRenewalConfig } from "./AddContractRenewal.formfield.config";
import { InputText } from "primereact/inputtext";
import { mapDropdownOptions } from "../../../../../../../components/finalForms/libs/data/mapDropdownOptions";
import { useGetClientByContractIdMutation, useInsertNewScopesWithCheckSerialNumberMutation, useLazyGetContractDepartmentsQuery } from "../../../../../../../app/services/contractAPI";
import { useLazyGetInstrumentTypeListQuery, useLazyGetScopeTypeListQuery } from "../../../../../../../app/services/commonAPI";
import ToastService from "../../../../../../../services/toastService/ToastService";
import SwalAlert from "../../../../../../../services/swalService/SwalService";
import PropTypes from "prop-types";

const AddRenewal = ({ contractId, onClose, gridRefresh }) => {

  const { confirm } = SwalAlert();
  const AddRenewalRef = useRef();
  const [contractRenewalForm, setContractRenewalForm] = useState(addRenewalConfig);
  const [count, setCount] = useState();
  const [gridData, setGridData] = useState(() =>
    Array.from({ length: count }, () => ({
      serialNumber: "",
      cost: "$0.00",
    }))
  );

  const [insertNewScopesWithCheckSerialNumber] = useInsertNewScopesWithCheckSerialNumberMutation();
  const [getAllClientsByContractId, {
    isFetching: isAllClientsByContractIdFetching,
    isSuccess: isAllClientsByContractIdFetched,
    data: allClientsByContractIdData,
  },] = useGetClientByContractIdMutation();

  const [getContractDepartments, {
    isFetching: isContractDepartmentsFetching,
    isSuccess: isContractDepartmentsFetched,
    data: ContractDepartmentsData,
  },] = useLazyGetContractDepartmentsQuery();

  const [getInstrumentTypes, {
    isFetching: isInstrumentFetching,
    isSuccess: isInstrumentSuccess,
    data: instrumentTypeData
  }] = useLazyGetInstrumentTypeListQuery();

  const [getAllScopeTypes, {
    isFetching: isScopeTypeFetching,
    isSuccess: isScopeTypeFetched,
    data: scopeTypesData
  }] = useLazyGetScopeTypeListQuery();

  useEffect(() => {
    if (contractId) {
      getAllClientsByContractId(contractId);
      getInstrumentTypes();
    }
  }, [contractId]);

  useEffect(() => {
    if (!isAllClientsByContractIdFetching && isAllClientsByContractIdFetched && allClientsByContractIdData) {
      const updatedConfig = { ...contractRenewalForm };
      mapDropdownOptions(updatedConfig, "NewScopeSection", "lClientKey", allClientsByContractIdData, "lClientKey", "sClientName1");
      setContractRenewalForm(updatedConfig);
    }
  }, [isAllClientsByContractIdFetching, isAllClientsByContractIdFetched, allClientsByContractIdData]);

  useEffect(() => {
    if (!isContractDepartmentsFetching && isContractDepartmentsFetched && ContractDepartmentsData) {
      const updatedConfig = { ...contractRenewalForm };
      mapDropdownOptions(updatedConfig, "NewScopeSection", "lDepartmentKey", ContractDepartmentsData, "lDepartmentKey", "department");
      setContractRenewalForm(updatedConfig);
    }
  }, [isContractDepartmentsFetching, isContractDepartmentsFetched, ContractDepartmentsData]);

  useEffect(() => {
    if (!isInstrumentFetching && isInstrumentSuccess && instrumentTypeData) {
      const updatedConfig = { ...contractRenewalForm };
      mapDropdownOptions(addRenewalConfig, 'NewScopeSection', 'sInstrumentTypeKey', instrumentTypeData, 'sInstrumentTypeKey', 'sInstrumentType')
      setContractRenewalForm(updatedConfig);
    }
  }, [isInstrumentFetching, isInstrumentSuccess, instrumentTypeData])

  useEffect(() => {
    if (!isScopeTypeFetching && isScopeTypeFetched && scopeTypesData) {
      const updatedConfig = { ...contractRenewalForm };
      mapDropdownOptions(updatedConfig, 'NewScopeSection', 'plScopeTypeKey', scopeTypesData, 'lScopeTypeKey', 'sScopeTypeDesc')
      setContractRenewalForm(updatedConfig);
    }
  }, [isScopeTypeFetching, isScopeTypeFetched, scopeTypesData]);

  useEffect(() => {
    if (count > 0) {
      const rows = Array.from({ length: count }, () => ({
        serialNumber: "",
        cost: "$0.00",
      }));
      setGridData(rows);
    }
  }, [count]);

  const handleFieldChange = (dataField, updatedFormData) => {
    let updatedState = { ...updatedFormData };
    if (dataField === "lClientKey") {
      const selectedClient =
        updatedFormData.lClientKey?.value ?? updatedFormData.lClientKey;

      getContractDepartments({
        plContractDepartmentKey: 0,
        plClientKey: selectedClient,
        plContractKey: contractId,
      });

      updatedState = {
        ...updatedState,
        lDepartmentKey: null
      };

      setContractRenewalForm((prev) => ({
        ...prev,
        initialState: updatedState,
      }));

      return;
    }

    if (dataField === "sInstrumentTypeKey") {
      const selectedInstrumentType =
        updatedFormData.sInstrumentTypeKey?.value ??
        updatedFormData.sInstrumentTypeKey;

      getAllScopeTypes(selectedInstrumentType);

      updatedState = {
        ...updatedState,
        plScopeTypeKey: null,
        lModelKey: null,
      };
      setContractRenewalForm((prev) => ({
        ...prev,
        initialState: updatedState,
      }));
      return;
    }
    setContractRenewalForm((prev) => ({
      ...prev,
      initialState: updatedState,
    }));
  };

  const resetForm = () => {
    const updatedForm = { ...contractRenewalForm };
    updatedForm.initialState = {};
    setContractRenewalForm(updatedForm);
  };


  const textEditor = (options) => {
    return (
      <InputText
        value={options.value || ""}
        onChange={(e) => options.editorCallback(e.target.value)}
        style={{ width: "70%" }}
        onFocus={(e) => {
          e.target.select();
        }}
      />
    );
  };

  const onCellEditComplete = (e) => {
    const { rowIndex, field, newValue } = e;
    setGridData((prev) => {
      const updated = [...prev];
      let finalValue = newValue;
      if (field === "cost") {
        const num = parseFloat(newValue) || 0;
        finalValue = `$${num.toFixed(2)}`;
      }
      updated[rowIndex] = { ...updated[rowIndex], [field]: finalValue };
      return updated;
    });
  };

  const onFieldBlure = (dataField, updatedData) => {
    if (dataField === "count") {
      const newCount = Number(updatedData?.count || 0);
      setCount(newCount);
    }
  };

  const handleSave = async () => {
    let formData = AddRenewalRef.current.getFormData();
    if (formData) {
      const invalidSerials = gridData.filter(x => !x.serialNumber || x.serialNumber.trim().length === 0);

      if (invalidSerials.length > 0) {
        if (gridData.length === 1) {
          ToastService.error("Invalid Serial Number.");
        } else {
          ToastService.error("There is at least one invalid Serial Number.");
        }
        return;
      }
      const req = gridData.map(i => ({
        psSerialNumber: i.serialNumber,
        pnCost: parseFloat((i.cost + "").replace(/[^0-9.]/g, "")) || 0,
        plScopeTypeKey: formData?.plScopeTypeKey?.value || 0,
        plContractKey: contractId,
        plDepartmentKey: formData?.lDepartmentKey?.value,
        pbRenewal: true,
      }));
      const result = await insertNewScopesWithCheckSerialNumber(req).unwrap();
      const existingSerials = result.filter(r => r.exists === true);
      if (existingSerials.length === 0) {
        ToastService.success("Scopes inserted successfully");
        onClose();
        resetForm();
        gridRefresh();
        return;
      }
      confirm(
        `Serial numbers already exist:\n${existingSerials.map(x => x.serialNumber).join(", ")}\n\nDo you want to insert them anyway?`,
        "",
        "Yes",
        "No",
      ).then(async (confirmed) => {
        if (!confirmed) {
          ToastService.info("Process stopped by user.");
          onClose();
          resetForm();
          gridRefresh();
          return;
        }
        const retryPayload = existingSerials.map(x => {
          const original = req.find(p => p.psSerialNumber === x.serialNumber);
          return {
            ...original,
            forceInsert: true
          };
        });
        await insertNewScopesWithCheckSerialNumber(retryPayload);
        onClose();
        gridRefresh();
        resetForm();
        ToastService.success("All duplicate scopes inserted successfully");
      });
    };
  }

  return (
    <div className="row">
      <FormCreator ref={AddRenewalRef} config={contractRenewalForm} onColumnChange={handleFieldChange} onFieldBlure={onFieldBlure} />
      <div className="scrollable-grid col-12">
        <MolGrid
          value={gridData}
          grouping
          expandableRowGroups={true}
          paginator={false}
          scrollable
          scrollHeight="flex"
          filterDisplay="row"
          sortMode="single"
          showGridlines
          resizableColumns
          metaKeySelection={true}
          editMode="cell"
        >
          <Column
            field="serialNumber"
            header="Serial Number"
            editor={textEditor}
            onCellEditComplete={onCellEditComplete}
            style={{ width: "60%" }}
          />
          <Column
            field="cost"
            header="Cost"
            editor={textEditor}
            onCellEditComplete={onCellEditComplete}
            style={{ width: "20%" }}
          />
        </MolGrid>
      </div>
      <div className="d-flex justify-content-end gap-3 export-icon">
        <Buttons
          buttonText="Save"
          onClick={handleSave}
          buttonTypeClassName="btn blue-btn"
          titleText="Save"
        // isLoading={isDeleting}
        />
        <Buttons
          buttonText="Cancel"
          onClick={onClose}
          buttonTypeClassName="btn blue-btn"
          titleText="Cancel"
        // isLoading={isDeleting}
        />
      </div>
    </div>
  );
};

AddRenewal.prototype = {
  contractId: PropTypes.number,
  onClose: PropTypes.func,
  gridRefresh: PropTypes.func
};
export default AddRenewal;
